import {
  CreateWorkAreaDocument,
  CreateWorkAreaMutation,
  CreateWorkAreaMutationVariables,
  GetWorkAreaMapsDocument,
  GetWorkAreasDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useCreateWorkArea = () => {
  const [executeMutation] = useMutation(CreateWorkAreaDocument, {
    extractorFn: (data: CreateWorkAreaMutation) => data.locationsMutations.createLocationsWorkArea,
  })

  const createWorkArea = async (variables: CreateWorkAreaMutationVariables) => {
    return executeMutation({
      variables,
      refetchQueries: [GetWorkAreasDocument, GetWorkAreaMapsDocument],
    })
  }

  return {
    createWorkArea,
  }
}
